module.exports = __webpack_public_path__ + "static/media/leaf_icon.9390fb2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leaf_icon.svg
// module id = 527
// module chunks = 0